import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ReservationApiModel } from '@rocksoft/inroom-sdk';

export const inRoomMobileReservationFeatureKey = 'mobile-reservation';

export function selectMobileReservationIdFrom(mobileReservation: ReservationApiModel): string {
  return mobileReservation?.Id ?? 'undefined';
}

export const adapter: EntityAdapter<ReservationApiModel> = createEntityAdapter<ReservationApiModel>({
  selectId: selectMobileReservationIdFrom,
});

export type MobileReservationState = EntityState<ReservationApiModel>;

export const initialState: MobileReservationState = adapter.getInitialState();
